import {
  Field,
  CellGroup,
  Calendar,
  Picker,
  Popup,
  Search,
  Checkbox,
  Sticky,
  Tab,
  Tabs,
  Skeleton,
  PullRefresh,
  List,
  ActionSheet,
  Swipe,
  SwipeItem,
  Dialog,
  FloatingPanel
} from 'vant'

// 抽离 vant 组件注册逻辑
export function registerVant(app) {
  app.use(Field)
  app.use(CellGroup)
  app.use(Calendar)
  app.use(Picker)
  app.use(Popup)
  app.use(Search)
  app.use(Checkbox)
  app.use(Sticky)
  app.use(Tab)
  app.use(Tabs)
  app.use(Skeleton)
  app.use(PullRefresh)
  app.use(List)
  app.use(ActionSheet)
  app.use(Swipe)
  app.use(SwipeItem)
  app.use(Dialog)
  app.use(FloatingPanel)
}
